import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg aria-hidden="true" data-prefix="fas" data-icon="pause" className={(styles["svg-inline--fa"] || "svg-inline--fa") + " " + (styles["fa-pause"] || "fa-pause") + " " + (styles["fa-w-14"] || "fa-w-14")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}><g fill="currentColor"><path d="M24 456V56h153.8v400H24zM270.2 456V56H424v400H270.2z" /></g></svg>);